module.exports = __webpack_public_path__ + "img/ii-jcyq.2e500572.png";